
/**
 * Polyfill to support the reactstrap Carousel.
 * See https://github.com/reactstrap/reactstrap/issues/799
 */
const script = `
(function () {
  function CustomEvent (event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()`
export default function ReactstrapPolyfill () {
  return <script dangerouslySetInnerHTML={{ __html: script }} />
}
